export default "__VITE_ASSET__hv60sXVZ__"